import _get from "lodash/get";
import { State as CheckoutState } from "./checkout";
import { MaybeEmpty } from "../../../../../constants";
import { ReSwitchState } from "../../../../../models/state";

export type State = CheckoutState;

export const getReSwitchData = (state: State): MaybeEmpty<ReSwitchState> => _get(state, "checkout.reSwitch", {});
export const getReSwitchExistingPhoneName = (state: State): string => getReSwitchData(state).name || "";
export const getReSwitchExistingPhoneNumber = (state: State): string => getReSwitchData(state).phoneNumber || "";
